/* eslint-disable @typescript-eslint/no-explicit-any */
import { Col, Form, Input, InputNumber } from "antd";
import TextArea from "antd/es/input/TextArea";

export function FormInput({
  id,
  name = "",
  label = "",
  placeholder = "",
  required = false,
  rules = undefined,
  widthSize = "medium",
  textArea = 0,
  inputType = "text",
  value = '',
  onChange = () => { },
  ...rest
}: any) {
  let spanSize;

    if (widthSize.toLowerCase() === "large") {
      spanSize = 24;
    } else if (widthSize.toLowerCase() === "small") {
      spanSize = 4;
    } else {
      spanSize = 8;
    }
  return (
    <Col span={spanSize}>
      <Form.Item label={label} name={name} rules={rules} layout="vertical">
        {(() => {
          if (textArea) {
            return (
              <TextArea
                showCount
                maxLength={textArea}
                placeholder={placeholder}
                autoComplete="off"
                onChange={onChange}
                {...rest}
              />
            );
          } else if (inputType.toLowerCase() === "number") {
            return (
              <InputNumber
                placeholder={placeholder}
                autoComplete="off"
                onChange={onChange}
                {...rest}
              />
            );
          } else if (inputType.toLowerCase() === "password") {
            return (
              <Input.Password
                placeholder={placeholder}
                autoComplete="off"
                onChange={onChange}
                value={value}
                {...rest}
              />
            );
          } else {
            return (
              <Input
                placeholder={placeholder}
                autoComplete="off"
                onChange={onChange}
                value={value}
                {...rest}
              />
            );
          }
        })()}
      </Form.Item>
    </Col>
  );
}
